import { CompanyMfaRequirement } from '../enums.js'

export const DEFAULT_MFA_REQUIREMENT = CompanyMfaRequirement.NONE

/** This is a company flag for gating access to the lien rights feature */
export const DEFAULT_ALLOW_LIEN_RIGHTS_TRACKING = false
/** Whether lien rights are automatically tracked by default for all new contracts */
export const DEFAULT_LIEN_RIGHTS_TRACKING = false

export const MIN_USER_SESSION_TIMEOUT = 5 // 5 minutes
export const MAX_USER_SESSION_TIMEOUT = 4 * 60 // 4 hours

/**
 * Upper bound for the pay app balance auto-close threshold (in cents). The feature is meant for
 * small rounding shortfalls, so we cap it generously at $1,000 to avoid accidentally closing large
 * balances.
 */
export const MAX_PAY_APP_BALANCE_AUTO_CLOSE_THRESHOLD_CENTS = 100_000
